import { render, staticRenderFns } from "./HospitalIntroGzyj.vue?vue&type=template&id=9e8507ea&scoped=true"
import script from "./HospitalIntroGzyj.vue?vue&type=script&lang=js"
export * from "./HospitalIntroGzyj.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroGzyj.vue?vue&type=style&index=0&id=9e8507ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8507ea",
  null
  
)

export default component.exports